<template>
  <div id="app">
    <!-- <img alt="Vue logo" src="./assets/logo.png"> -->
    <!-- <HelloWorld msg="Welcome to Your Vue.js App"/> -->
     <router-view/>
  </div>
</template>

<script>
  
// import HelloWorld from './components/HelloWorld.vue'

export default {
  name: 'app',
  components: {
    // HelloWorld
  }
}
</script>

<style lang = "scss">
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin:0 auto;
  max-width:1170px;
  

  

  .button{
    padding: 0;
    width: 48%;
    color: #fff;
    margin: 1px;
    height: 60px;
    background: #666;
    text-align: center;
    white-space: nowrap;
    vertical-align: top;
    display: inline-block;
    text-decoration: none;
    border: 3px solid #666;
    font: 21px/60px 'Muli', Arial, Helvetica, sans-serif;
}
.button--reset{
  opacity: 0.4;
}

.button--reset:hover{
  opacity: 0.6;
}










}
</style>
